export default "__VITE_ASSET__WSZzGEoW__"